import EmployEngageLogo from '../employ-engage-logo/employ-engage-logo';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { LanguagePicker } from '../language-picker/language-picker';

export interface HeaderProps {
  hideLogo?: boolean;
  rightSide?: ReactNode;
  onLogoClickGoHome?: boolean;
  className?: string;
  isMultiLanguageEnabled?: boolean;
}

export function Header({
  hideLogo,
  rightSide,
  onLogoClickGoHome,
  className,
  isMultiLanguageEnabled,
}: HeaderProps) {
  return (
    <div
      className={classNames(
        'px-5 sm:px-10 flex justify-between items-center',
        className
      )}
    >
      <div className={classNames(hideLogo && 'opacity-0')}>
        {onLogoClickGoHome ? (
          <Link to="/">
            <EmployEngageLogo />
          </Link>
        ) : (
          <EmployEngageLogo />
        )}
      </div>

      <div className="flex items-center gap-4">
        {isMultiLanguageEnabled && <LanguagePicker />}
        {rightSide}
      </div>
    </div>
  );
}

export default Header;
